'use client';

import { default as dynImport } from 'next/dynamic';
import { DynamicClientComponent, TemplatePageComponent } from '@/utils/types'
import { gql, getAppComponent, getComponentConfig } from "@/utils/api";
import { app_component, info, shop } from '@/types/graphql';
import { blog_post } from "@/types/graphql";

export default async function Blog({ module, slug }: { module: TemplatePageComponent, slug: string })
{

	const appComponent: Partial<app_component> | null | undefined = await getAppComponent(module);

	if (!appComponent)
	{
		return;
	}

	const componentConfig: any = await getComponentConfig(module);

	let limit = '';
	if (componentConfig && componentConfig['data'] && componentConfig['data']['posts_number'] && componentConfig['data']['posts_number']['value'] && componentConfig['data']['posts_number']['value'] > 0)
	{
		limit = `, limit: ${componentConfig['data']['posts_number']['value']}`;
	}

	const json = await gql(JSON.stringify({
		"query": `query ($id: Int, $slug: String) {
			blog_post(where: {shop_id: {_eq: $id}, slug: {_eq: $slug }}) {
				author
				title
				publish_date
				content
				image_id
				blog_post_blog_tags {
					blog_tag {
						title
					}
				}
			}

			info(where: {id: {_eq: $id}}) {
				blog_title
        lat
        lng
      }

		}`, "variables": { "id": parseInt(process.env.SHOP_ID ?? "0"), "slug": slug }
	}));

	const json_blog = await gql(JSON.stringify({
		"query": `query ($id: Int, $slug: String) {
			
			blog_post(where: {shop_id: {_eq: $id}, _not: {slug: {_eq: $slug }}}${limit}) {
				enabled	
				author
				title
				publish_date
				slug
				content
				image_id
				blog_post_blog_tags {
					blog_tag {
						title
					}
				}
			}
			
		}`, "variables": { "id": parseInt(process.env.SHOP_ID ?? "0"), "slug": slug }
	}));

	const data: { blog_posts: blog_post[], relative_blog_posts: blog_post[], info: info } = { blog_posts: [] as blog_post[], relative_blog_posts: [] as blog_post[], info: {} as info };

	if (json?.data && json?.data?.blog_post)
	{
		data.blog_posts = json?.data?.blog_post;
	}

	if (json_blog?.data && json_blog?.data?.blog_post)
	{
		data.relative_blog_posts = json_blog?.data?.blog_post;
	}

	if (json?.data && json?.data?.info && json?.data?.info?.at(0))
	{
		data.info = json?.data?.info?.at(0);
	}

	let Blog = dynImport<DynamicClientComponent>(() => import(`@/components/${appComponent.path}`));

	return (
		<Blog data={data} config={componentConfig}></Blog>
	)
}


